"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeAccountType = exports.normalizeBankName = exports.getBanksForContext = exports.ACCOUNT_TYPES = exports.BANKS = void 0;
exports.BANKS = [
    { label: "Bank Windhoek", value: "Bank Windhoek" },
    { label: "First National Bank", value: "First National Bank" },
    { label: "Nedbank", value: "Nedbank" },
    { label: "Standard Bank", value: "Standard Bank" },
    { label: "Trutsco Bank", value: "Trutsco Bank" },
    { label: "Banco Atlantico", value: "Banco Atlantico" },
    { label: "Bank BIC Namibia", value: "Bank BIC Namibia" },
    { label: "Letshego Bank Namibia", value: "Letshego Bank Namibia" },
    { label: "NamPost Bank", value: "NamPost Bank" },
];
exports.ACCOUNT_TYPES = [
    { label: "Cheque", value: "Cheque" },
    { label: "Savings", value: "Savings" },
];
// Context-aware bank filtering
// NamPost Bank is only available for lay-buy applications
var getBanksForContext = function (context) {
    switch (context) {
        case "laybuy":
            return exports.BANKS; // All banks including NamPost
        default:
            return exports.BANKS.filter(function (bank) { return bank.value !== "NamPost Bank"; });
    }
};
exports.getBanksForContext = getBanksForContext;
// Normalize bank names from database abbreviations to full names
var normalizeBankName = function (dbValue) {
    if (!dbValue)
        return "";
    var mapping = {
        fnb: "First National Bank",
        "first national bank": "First National Bank",
        standard: "Standard Bank",
        "standard bank": "Standard Bank",
        nedbank: "Nedbank",
        "bank windhoek": "Bank Windhoek",
        windhoek: "Bank Windhoek",
        trutsco: "Trutsco Bank",
        "trutsco bank": "Trutsco Bank",
        "banco atlantico": "Banco Atlantico",
        atlantico: "Banco Atlantico",
        "bank bic": "Bank BIC Namibia",
        "bank bic namibia": "Bank BIC Namibia",
        bic: "Bank BIC Namibia",
        letshego: "Letshego Bank Namibia",
        "letshego bank namibia": "Letshego Bank Namibia",
        "letshego bank": "Letshego Bank Namibia",
        nampost: "NamPost Bank",
        "nampost bank": "NamPost Bank",
    };
    // Try exact match first (case-insensitive)
    var normalized = mapping[dbValue.toLowerCase()];
    if (normalized)
        return normalized;
    // If no match, return original value (might already be correct)
    return dbValue;
};
exports.normalizeBankName = normalizeBankName;
// Normalize account type (handle case variations)
var normalizeAccountType = function (dbValue) {
    if (!dbValue)
        return "";
    // Capitalize first letter, lowercase the rest
    var normalized = dbValue.charAt(0).toUpperCase() + dbValue.slice(1).toLowerCase();
    // Validate against known types
    var validTypes = exports.ACCOUNT_TYPES.map(function (t) { return t.value; });
    if (validTypes.includes(normalized)) {
        return normalized;
    }
    // Return original if doesn't match
    return dbValue;
};
exports.normalizeAccountType = normalizeAccountType;
